import auth from '@stores/auth';
import { useStore } from 'effector-react';
import ROLES from '@constants/roles';

const useGuards = () => {
  const { user: authUser } = useStore(auth);
  const isAdmin = authUser?.role === ROLES.ADMIN;
  const isCommunityManager = authUser?.role === ROLES.COMMUNITY_MANAGER;
  const isDeveloper = authUser?.role === ROLES.DEVELOPER;
  const isModerator = authUser?.role === ROLES.MODERATOR;

  const allowChange = isCommunityManager || isAdmin;
  const allowCRUD = isAdmin;
  const allowModerate = isModerator;

  return {
    isAdmin,
    isCommunityManager,
    isDeveloper,
    isModerator,
    allowChange,
    allowCRUD,
    allowModerate
  }
}

export default useGuards;
